import PortalIdParser from 'PortalIdParser';
const portalId = PortalIdParser.get();
export const normalizeCustomIdentifier = identifier => {
  if (identifier.startsWith('2-') || identifier.startsWith(`p${portalId}`)) {
    return 'customObject';
  } else if (identifier.startsWith('6-') || identifier.startsWith(`pe${portalId}`)) {
    return 'customEvent';
  }
  return identifier;
};